import { FC } from "react";

import { useFullUserProfileContext } from "Bands/contexts";
import { copy } from "shared/assets";
import { Loader, Title, VehicleTeaser } from "shared/components";
import { Spacer } from "shared/layout";
import { useFetchingUserDocuments } from "Bands/utils";
import { GridContainer } from "shared/styles";

const vehicleCopy = copy.userVehicle;

export const Vehicles: FC = () => {
  const { vehicles } = useFullUserProfileContext();

  const { fetchingVehicles } = useFetchingUserDocuments();

  if (fetchingVehicles) return <Loader />;
  if (!vehicles?.length) return null;

  return (
    <Spacer size="m">
      <Title title={vehicleCopy.title} asComponent="h3" size="s" />
      <GridContainer>
        {vehicles?.map(vehicle => (
          <VehicleTeaser key={vehicle.id} {...vehicle} />
        ))}
      </GridContainer>
    </Spacer>
  );
};
